import React from "react";

export const Team = (props) => {
  const members = props.data || [];

  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Unser Team</h2>
          <p>
            Kompetent, engagiert und erfahren – unser Team realisiert Ihre Projekte zuverlässig.
          </p>
        </div>

        {/* Grid statt fester Bootstrap-Spalten: zentriert bei einer Person,
            wächst automatisch mit, sobald weitere dazukommen. */}
        <div className="team-grid">
          {members.map((d, i) => (
            <figure key={`${d.name}-${i}`} className="team-card">
              <div className="team-photo">
                <img
                  src={d.img}
                  alt={`${d.name} – ${d.job} bei Merdovic Trockenbau`}
                  loading="lazy"
                  decoding="async"
                  width="1200"
                  height="1500"
                />
              </div>
              <figcaption className="team-caption">
                <h3>{d.name}</h3>
                <p>{d.job}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </div>
  );
};
